var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Patient Big@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-322.000000, -242.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#00A8FF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(254.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patients",
    transform: "translate(36.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Big",
    transform: "translate(33.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3,5.8 L37.7,5.8 L37.7,2.9 C37.7,1.29837423 36.4016258,0 34.8,0 L23.2,0 C21.5983742,0 20.3,1.29837423 20.3,2.9 L20.3,5.8 L8.7,5.8 C3.89512268,5.8 0,9.69512268 0,14.5 L0,49.3 C0,54.1048773 3.89512268,58 8.7,58 L49.3,58 C54.1048773,58 58,54.1048773 58,49.3 L58,14.5 C58,9.69512268 54.1048773,5.8 49.3,5.8 Z M26.1,5.8 L31.9,5.8 L31.9,11.6 L26.1,11.6 L26.1,5.8 Z M52.2,49.3 C52.2,50.9016258 50.9016258,52.2 49.3,52.2 L8.7,52.2 C7.09837423,52.2 5.8,50.9016258 5.8,49.3 L5.8,14.5 C5.8,12.8983742 7.09837423,11.6 8.7,11.6 L20.3,11.6 L20.3,14.5 C20.3,16.1016258 21.5983742,17.4 23.2,17.4 L34.8,17.4 C36.4016258,17.4 37.7,16.1016258 37.7,14.5 L37.7,11.6 L49.3,11.6 C50.9016258,11.6 52.2,12.8983742 52.2,14.5 L52.2,49.3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.902,37.12 C37.0521784,35.6213594 37.6833031,33.789062 37.7,31.9 C37.7,27.0951227 33.8048773,23.2 29,23.2 C24.1951227,23.2 20.3,27.0951227 20.3,31.9 C20.3166969,33.789062 20.9478216,35.6213594 22.098,37.12 C19.1551831,39.2985347 17.4136603,42.7385797 17.4,46.4 L23.2,46.4 C23.2,43.1967485 25.7967485,40.6 29,40.6 C32.2032515,40.6 34.8,43.1967485 34.8,46.4 L40.6,46.4 C40.5863397,42.7385797 38.8448169,39.2985347 35.902,37.12 L35.902,37.12 Z M26.1,31.9 C26.1,30.2983742 27.3983742,29 29,29 C30.6016258,29 31.9,30.2983742 31.9,31.9 C31.9,33.5016258 30.6016258,34.8 29,34.8 C27.3983742,34.8 26.1,33.5016258 26.1,31.9 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientBig);
export default __webpack_public_path__ + "static/media/patient-big.fea59a6a01cc4f1b524ef9ecd2d20acf.svg";
export { ForwardRef as ReactComponent };